module.exports = __webpack_public_path__ + "static/media/ic-checkmark-gray.daba6b32.svg";